import { render, staticRenderFns } from "./changeLangApp.vue?vue&type=template&id=4efe5398"
import script from "./changeLangApp.vue?vue&type=script&lang=js"
export * from "./changeLangApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports